import React from "react";
import ErrorMessage from "./ErrorMessage";
import UserService from "../Services/userService";
import urlHelper from "../Helpers/urlHelper";

export default class InferiorUsers extends React.Component {
  static defaultProps = {
    supervisorId: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      users: [],
    };
  }

  componentDidMount() {
    this.populateData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.supervisorId !== prevProps.supervisorId) {
      this.populateData();
    }
  }

  populateData() {
    UserService.getUsersBySupervisorId(this.props.supervisorId)
      .then((response) => {
        this.setState({ users: response });
      })
      .catch((error) => ErrorMessage.SetErrorMessage("IFU22"));
  }

  render() {
    const list = this.state.users.map((user) => <li key={user.userId}>{urlHelper.getLinkComponent(`${user.name} (${user.userId})`, "home_users/search", `Id=${user.userId}`)}</li>);
    return <ul>{list}</ul>;
  }
}
